// 50 US states with major cities (used for local SEO landing pages)
const RAW = [
  ["Alabama", "AL", ["Birmingham", "Montgomery", "Huntsville", "Mobile", "Tuscaloosa"]],
  ["Alaska", "AK", ["Anchorage", "Fairbanks", "Juneau", "Wasilla"]],
  ["Arizona", "AZ", ["Phoenix", "Tucson", "Mesa", "Scottsdale", "Chandler"]],
  ["Arkansas", "AR", ["Little Rock", "Fayetteville", "Fort Smith", "Springdale", "Jonesboro"]],
  ["California", "CA", ["Los Angeles", "San Diego", "San Jose", "San Francisco", "Sacramento"]],
  ["Colorado", "CO", ["Denver", "Colorado Springs", "Aurora", "Fort Collins", "Boulder"]],
  ["Connecticut", "CT", ["Bridgeport", "New Haven", "Hartford", "Stamford", "Waterbury"]],
  ["Delaware", "DE", ["Wilmington", "Dover", "Newark", "Middletown"]],
  ["Florida", "FL", ["Miami", "Orlando", "Tampa", "Jacksonville", "Fort Lauderdale"]],
  ["Georgia", "GA", ["Atlanta", "Savannah", "Augusta", "Columbus", "Macon"]],
  ["Hawaii", "HI", ["Honolulu", "Hilo", "Kailua", "Pearl City"]],
  ["Idaho", "ID", ["Boise", "Meridian", "Nampa", "Idaho Falls", "Pocatello"]],
  ["Illinois", "IL", ["Chicago", "Aurora", "Naperville", "Rockford", "Springfield"]],
  ["Indiana", "IN", ["Indianapolis", "Fort Wayne", "Evansville", "South Bend", "Carmel"]],
  ["Iowa", "IA", ["Des Moines", "Cedar Rapids", "Davenport", "Sioux City", "Iowa City"]],
  ["Kansas", "KS", ["Wichita", "Overland Park", "Kansas City", "Topeka", "Olathe"]],
  ["Kentucky", "KY", ["Louisville", "Lexington", "Bowling Green", "Owensboro", "Covington"]],
  ["Louisiana", "LA", ["New Orleans", "Baton Rouge", "Shreveport", "Lafayette", "Lake Charles"]],
  ["Maine", "ME", ["Portland", "Lewiston", "Bangor", "Augusta"]],
  ["Maryland", "MD", ["Baltimore", "Columbia", "Germantown", "Silver Spring", "Frederick"]],
  ["Massachusetts", "MA", ["Boston", "Worcester", "Springfield", "Cambridge", "Lowell"]],
  ["Michigan", "MI", ["Detroit", "Grand Rapids", "Warren", "Ann Arbor", "Lansing"]],
  ["Minnesota", "MN", ["Minneapolis", "Saint Paul", "Rochester", "Duluth", "Bloomington"]],
  ["Mississippi", "MS", ["Jackson", "Gulfport", "Southaven", "Hattiesburg", "Biloxi"]],
  ["Missouri", "MO", ["Kansas City", "St. Louis", "Springfield", "Columbia", "Independence"]],
  ["Montana", "MT", ["Billings", "Missoula", "Great Falls", "Bozeman", "Helena"]],
  ["Nebraska", "NE", ["Omaha", "Lincoln", "Bellevue", "Grand Island", "Kearney"]],
  ["Nevada", "NV", ["Las Vegas", "Henderson", "Reno", "North Las Vegas", "Sparks"]],
  ["New Hampshire", "NH", ["Manchester", "Nashua", "Concord", "Dover", "Rochester"]],
  ["New Jersey", "NJ", ["Newark", "Jersey City", "Paterson", "Trenton", "Edison"]],
  ["New Mexico", "NM", ["Albuquerque", "Las Cruces", "Rio Rancho", "Santa Fe", "Roswell"]],
  ["New York", "NY", ["New York City", "Buffalo", "Rochester", "Yonkers", "Syracuse"]],
  ["North Carolina", "NC", ["Charlotte", "Raleigh", "Greensboro", "Durham", "Winston-Salem"]],
  ["North Dakota", "ND", ["Fargo", "Bismarck", "Grand Forks", "Minot"]],
  ["Ohio", "OH", ["Columbus", "Cleveland", "Cincinnati", "Toledo", "Akron"]],
  ["Oklahoma", "OK", ["Oklahoma City", "Tulsa", "Norman", "Broken Arrow", "Edmond"]],
  ["Oregon", "OR", ["Portland", "Salem", "Eugene", "Gresham", "Bend"]],
  ["Pennsylvania", "PA", ["Philadelphia", "Pittsburgh", "Allentown", "Erie", "Harrisburg"]],
  ["Rhode Island", "RI", ["Providence", "Warwick", "Cranston", "Pawtucket"]],
  ["South Carolina", "SC", ["Charleston", "Columbia", "Greenville", "Myrtle Beach", "Rock Hill"]],
  ["South Dakota", "SD", ["Sioux Falls", "Rapid City", "Aberdeen", "Brookings"]],
  ["Tennessee", "TN", ["Nashville", "Memphis", "Knoxville", "Chattanooga", "Clarksville"]],
  ["Texas", "TX", ["Houston", "Dallas", "San Antonio", "Austin", "Fort Worth"]],
  ["Utah", "UT", ["Salt Lake City", "West Valley City", "Provo", "Ogden", "St. George"]],
  ["Vermont", "VT", ["Burlington", "South Burlington", "Rutland", "Montpelier"]],
  ["Virginia", "VA", ["Virginia Beach", "Richmond", "Norfolk", "Chesapeake", "Arlington"]],
  ["Washington", "WA", ["Seattle", "Spokane", "Tacoma", "Vancouver", "Bellevue"]],
  ["West Virginia", "WV", ["Charleston", "Huntington", "Morgantown", "Parkersburg"]],
  ["Wisconsin", "WI", ["Milwaukee", "Madison", "Green Bay", "Kenosha", "Racine"]],
  ["Wyoming", "WY", ["Cheyenne", "Casper", "Laramie", "Gillette"]],
];

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const STATES = RAW.map(([name, abbr, cities]) => ({ name, abbr, cities, slug: slugify(name) }));

export const stateBySlug = (slug) => STATES.find((s) => s.slug === slug);

export const statePath = (s) => `/sell-test-strips/${s.slug}`;

// Pick 6 other states near in the list for internal linking
export const relatedStates = (s) => {
  const i = STATES.findIndex((x) => x.slug === s.slug);
  const out = [];
  for (let d = 1; out.length < 6 && d < STATES.length; d++) {
    if (STATES[i + d]) out.push(STATES[i + d]);
    if (out.length < 6 && STATES[i - d]) out.push(STATES[i - d]);
  }
  return out;
};

const INTROS = [
  (s, c) => `Do you have sealed, unexpired supplies sitting in a closet in ${c[0]} or ${c[1]}? StripWise gives people all over ${s.name} a simple way to sell the extras they no longer need.`,
  (s, c) => `Whether you live in ${c[0]}, ${c[1]} or a small town anywhere in ${s.name}, you can get a free quote from StripWise without leaving home.`,
  (s, c) => `From ${c[0]} to ${c[c.length - 1]}, people in ${s.name} use StripWise to give sealed test strips and supplies a second life. Shipping is free and our team keeps you updated.`,
];

export const stateIntro = (s) => INTROS[STATES.findIndex((x) => x.slug === s.slug) % INTROS.length](s, s.cities);

export const stateFaqs = (s, phone) => [
  { q: `Can I sell diabetic test strips in ${s.name}?`, a: `Yes. StripWise accepts sealed, unexpired test strips and supplies from people anywhere in ${s.name}, including ${s.cities.slice(0, 3).join(", ")}.` },
  { q: `How do I ship my test strips from ${s.name}?`, a: `Once you accept your quote, we email you a prepaid shipping label. Pack your sealed boxes securely and drop the package off at a post office in ${s.name}.` },
  { q: `How do I get paid in ${s.name}?`, a: `After your package arrives and our team checks it, we send payment using the method you chose: Zelle, PayPal, Venmo, Cash App, Chime or ACH.` },
  { q: `Is there a test strip buyer near me in ${s.cities[0]}?`, a: `You don't need a local store. StripWise works by mail across all of ${s.name}. Call or text ${phone}, or chat with us, for a free quote.` },
];

// ---------- City pages ----------
export const cityPath = (s, c) => `/sell-test-strips/${s.slug}/${slugify(c)}`;
export const cityBySlug = (s, citySlug) => s?.cities.find((c) => slugify(c) === citySlug);

const CITY_INTROS = [
  (c, s) => `Live in ${c} and have sealed, unexpired supplies you no longer need? StripWise makes selling them simple: get a free quote, then ship free from any post office in ${c}.`,
  (c, s) => `No need for classified ads in ${c}. StripWise accepts sealed test strips and supplies from ${c}, ${s.abbr} with a free quote and a prepaid shipping label.`,
  (c, s) => `Clear out the extra sealed supplies in your ${c} home. StripWise serves ${c} and all of ${s.name} by mail, and real people answer when you call.`,
];
export const cityIntro = (s, c) => CITY_INTROS[(s.cities.indexOf(c) + STATES.findIndex((x) => x.slug === s.slug)) % CITY_INTROS.length](c, s);

export const cityFaqs = (s, c, phone) => [
  { q: `Where can I sell diabetic test strips in ${c}, ${s.abbr}?`, a: `You can sell them to StripWise by mail from anywhere in ${c}. Chat with us or call or text ${phone} for a free quote, then ship with our prepaid label.` },
  { q: `How do I ship from ${c}?`, a: `Use the prepaid label we email you with your quote and drop the box off at a post office near you in ${c}.` },
  { q: `How are offers decided in ${c}?`, a: `Offers are the same nationwide and depend on quantity, condition and expiration dates. See our offer guide or send a photo of your boxes in the live chat.` },
  { q: `How do ${c} sellers get paid?`, a: `After your package arrives and is checked, we pay you with the method you chose: Zelle, PayPal, Venmo, Cash App, Chime or ACH.` },
];
